import React from "react"
import { PropertiesNamesOfType } from "../componentExtensions";
import { formGroup } from "./formGroup";
import { TextInput } from "./textInput";

interface NumberInputProps<T> extends Omit<React.InputHTMLAttributes<HTMLInputElement>, "name" | "value" | "onChange"> {
    label?: string;
    error?: string;
    helpText?: string;
    value: number | undefined;
    onChange: (value: number) => void;
    name?: PropertiesNamesOfType<T, number | undefined>;
}

interface State { value: string | undefined }
export default class NumberInput<T> extends React.Component<NumberInputProps<T>, State>{

    constructor(props: NumberInputProps<T>) {
        super(props);
        this.state = {
            value: props.value?.toString(),
        }
    }

    componentDidUpdate(oldProps: NumberInputProps<T>, oldState: State) {
        if (this.props.value !== oldProps.value)
            this.setState({ value: this.props.value?.toString() })
    }

    render() {
        return <TextInput<T>
            {...this.props}
            type="text"
            value={this.state.value}
            onChange={e => {
                const value = e.target.value.replace(",", ".");
                this.setState({ value });
                if (!isNaN(+value))
                    this.props.onChange(+value)
            }}
            error={this.props.error}
            name={this.props.name as any}
        />
    }

}


export const FormNumberInput: <T>(props: NumberInputProps<T>) => React.ReactElement | null = formGroup(NumberInput as any) as any